<template>
    <div class="h-100">
        <md-card-media class="card-community-banner">
            <img :src="card.cover ? card.cover : bannerPlaceholder" />
        </md-card-media>
        <md-card-content class="community-card">
            <img :src="card.logo ? card.logo : logoPlaceholder" class="community-logo" />
            <h2 class="community-name">{{card.name}}</h2>
            <h4>
                <span
                    class="topic"
                    v-for="(topic, index) in card.topics"
                    :key="index"
                >{{topic.name}} {{card.topics.length > index+1 ? '-' : ''}}</span>
                <div class="community-location">
                    <span
                        v-for="(location, index) in card.basedIn"
                        :key="index"
                    >{{location.city}}, {{location.country}}{{card.basedIn.length>1 && card.basedIn.length-1>index ? " - " : ""}}</span>
                </div>
            </h4>
            <div v-if="management" class="wrap-info-btn-manage d-flex align-items-end mt-auto">
                <div class="mr-2">
                    <div class="txt-status-card">Status:</div>
                    <div class="status-label" :class="card.status">{{card.status}}</div>
                </div>
                <span class="d-flex flex-wrap justify-content-end ml-auto">
                    <a
                        :href="conf.community_url+'/'+card.slug+((card.status === 'pending')?'/preview':'')"
                        v-if="card.status==='active' || card.status ==='inactive' || card.status === 'pending'"
                    >
                        <button class="btn btn-outline-success mt-1 mx-1">VIEW</button>
                    </a>
                    <router-link :to="`/communities/${card.id}/manage`">
                        <button class="btn btn-primary mt-1 mx-1">manage</button>
                    </router-link>
                </span>
            </div>
        </md-card-content>
    </div>
</template>
<script>
export default {
    name: "CommunityCard",
    props: ["card", "management"],
    data: () => ({
        logoPlaceholder: "/img/logo-default.png"
    }),
    computed: {
        conf() {
            return this.$store.getters.conf;
        },
        bannerPlaceholder() {
            return (
                "/img/banner-default/" +
                (Math.floor(Math.random() * 5) + 1) +
                ".jpg"
            );
        }
    }
};
</script>
<style lang="scss">
@import "@/assets/scss/_common.scss";
.card-community-banner {
    img {
        height: 180px;
        object-fit: cover;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
        -webkit-border-top-left-radius: 5px;
        -webkit-border-top-right-radius: 5px;
        -moz-border-radius-topleft: 5px;
        -moz-border-radius-topright: 5px;
    }
}
.community-card {
    // text-align: center;
    height: calc(100% - 180px);
    display: flex;
    flex-direction: column;
    &.md-card-content {
        padding: 25px 21px 25px 25px;
        .topic:first-child {
            margin-left: 0;
        }
    }
    .btn {
        font-size: 14px;
        width: 48% !important;
    }
    .community-logo {
        width: 100px;
        height: 100px;
        border: solid 4px #ffffff;
        background-color: #ffffff;
        position: absolute;
        border-radius: 50%;
        // left: calc(50% - 54px);
        left: 25px;
        top: -54px;
        object-fit: cover;
    }

    .community-name {
        margin-top: 26px;
        font-size: 22px;
        font-weight: 600;
        color: $palette-blue;
    }

    h4 {
        .community-location > span {
            margin-right: 5px;
            color: #969696;
            margin-top: 11px;
            font-size: 16px;
        }
    }

    .topic {
        margin: 3px;
        font-size: 16px;
        color: $palette-blue;
    }
}

.wrap-info-btn-manage {
    .txt-status-card {
        color: $palette-blue;
        font-size: 13px;
    }

    .status-label {
        font-size: 15px;
        font-weight: 700;
        color: #fff;
        padding: 2px 10px;
        display: inline-block;
        border-radius: 4px;
        margin-top: 4px;
        background-color: #ff5c00;
        text-transform: capitalize;

        &.active {
            background-color: #087505;
        }
        &.pending {
            background-color: #e19626;
        }
        &.inactive {
            border: 2px solid #417505;
        }
        &.hidden {
            border: 2px dashed darkgray;
            background: #e5e5e5;
            color: darkgray;
        }
    }
}
</style>
